import {
    TRAINERS_PATCH_FAILURE,
    TRAINERS_PATCH_REQUEST,
    TRAINERS_PATCH_SUCCESS,
} from 'actions';

const initialState = {
    patching: false,
    hasErrors: false,
};

export default (state = initialState, action) => {
    const {type, trainer} = action;
    switch (type) {
        case TRAINERS_PATCH_SUCCESS: {return {
            ...initialState,
            trainer,
        }}

        case TRAINERS_PATCH_REQUEST: {return {
            ...initialState,
            patching: true,
        }}

        case TRAINERS_PATCH_FAILURE: {return {
            ...initialState,
            hasErrors: true,
        }}

        default: { return state }
    }
};
